// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/line
import axios from 'axios';
import { useEffect, useState } from 'react';
import { format, isValid } from 'date-fns';
import { ResponsivePie } from '@nivo/pie';
import { apiEndpoint } from '../constants/api';
import PieChartData from './PieChart.json';
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const colors = ['hsl(198, 70%, 50%)', 'hsl(75, 70%, 50%)', 'hsl(250, 70%, 50%)', 'hsl(20, 70%, 50%)'];

export const JobCandidateLgbtqChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);
  const loadData = async () => {

    const processData = data.reduce((acc, curr) => {
      if(acc.find(g => g.label === (curr.lgbtqia ? 'LGBTQIA' : 'Not LGBTQ'))){
        acc.forEach(g => {
          if(g.label === curr.lgbtqia ? 'LGBTQIA' : 'Not LGBTQ')
            g.value += 1
        })
      } else {
        acc.push({ 
          id: (curr.lgbtqia ? 'LGBTQIA' : 'Not LGBTQ'), 
          label: (curr.lgbtqia ? 'LGBTQIA' : 'Not LGBTQ'), 
          value: 1, 
          color: colors[acc.length]
        });
      }
      return acc;

    }, []);
    setChartData(processData);
  };

  useEffect(() => {
    loadData();
  }, [data]);

  return (
    <ResponsivePie
      data={chartData}
      colors={{ scheme: 'dark2' }}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 0.2]],
      }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [['darker', 2]],
      }}
      defs={[
        {
          id: 'dots',
          type: 'patternDots',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: 'lines',
          type: 'patternLines',
          background: 'inherit',
          color: 'rgba(255, 255, 255, 0.3)',
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: 'Man',
          },
          id: 'dots',
        },
        {
          match: {
            id: 'Woman',
          },
          id: 'lines',
        },
      ]}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: -10,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: '#999',
          itemDirection: 'left-to-right',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
    />
  );
};
